package com.exura.features.plandefinition.data.remote.dto.element

import com.exura.features.plandefinition.domain.model.element.ElementType
import com.exura.features.plandefinition.domain.model.series.HourOfDay
import com.exura.features.plandefinition.domain.model.series.PartOfDay
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * DTO for InstructionElement.
 * Extends BasePlanElementDto for Firebase storage compatibility.
 */
@Serializable
@SerialName("instruction_element")
data class InstructionElementDto(
    override val elementType: String = ElementType.INSTRUCTION.name,
    override val durationInMinutes: Int,
    override val durationInDays: Int,
    val relativeDay: Int,
    val title: String,
    val instruction: String,
    val partOfDay: PartOfDay? = null,
    val exactTime: HourOfDay? = null,
    override val imageUrl: String? = null
) : BasePlanElementDto()
